/**
 * Utility functions used by reducers.
 * Extracted to a separate file to avoid circular dependencies with utils.ts -> reducers.ts
 */
import { forEach, get, has, includes, isEmpty, isNil, set } from 'lodash';
import { dayjs } from '@trip-ux/common';
import { STORE } from './global';

/**
 * Checks if a store is in the whitelist and returns current or initial state accordingly.
 */
export const checkWhitelist = (
  whitelist: STORE[],
  storeName: STORE,
  currentState: unknown,
  initialState: unknown
): unknown => {
  if (includes(whitelist, storeName)) {
    return currentState;
  } else {
    return initialState;
  }
};

/**
 * Formats date fields in an object from one format to another.
 */
export const formatDateFields = (
  object: Record<string, unknown>,
  fields: string[],
  previousDateFormat: string,
  newDateFormat: string
): Record<string, unknown> => {
  forEach(fields, field => {
    const fieldValue = get(object, `${field}`) as string;
    if (!isEmpty(fieldValue)) {
      set(object, `${field}`, dayjs(fieldValue, previousDateFormat).format(newDateFormat));
    }
  });
  return object;
};

/**
 * Checks if a date translation is needed for a given key in an object.
 */
export const isToTranslateDate = (previousDateFormat: string, object: unknown, key: string): boolean => {
  return !isNil(previousDateFormat) && has(object, key);
};
